// extracted by mini-css-extract-plugin
module.exports = {"title":"j_Y f_G","mainImage":"j_Z","mainImageCaption":"j_0 f_t","grid":"j_V","metaContent":"j_1","publishedAt":"j_2 f_t","updatedAt":"j_3 f_t"};